/**
 * User identity constants for anonymous collaboration
 *
 * These constants are used by auth.ts to assign random identities to new users.
 * Actual identity management is handled by Supabase profiles.
 */

/**
 * Cocktail-themed aliases for anonymous users
 */
export const COCKTAIL_ALIASES = [
  'Dry Martini', // James Bond (1962)
  'Vesper Martini', // Casino Royale (2006)
  'Mojito',
  'Negroni',
  'Margarita',
  'Banana Daiquiri', // The Godfather Part II (1974)
  'Manhattan',
  'Old Fashioned', // Mad Men
  'Cosmopolitan',
  'Mai Tai',
  'Caipirinha',
  'Singapore Sling',
  'Whiskey Sour',
  'Aperol Spritz',
  'Gimlet',
  'Sidecar',
  'Moscow Mule',
  'Last Word',
  'Cuba Libre',
  'Charlie Chaplin',
  'White Lady',
] as const

/**
 * Color palette for user avatars
 * Carefully chosen for good contrast and visibility
 */
export const USER_COLORS = [
  '#FF6B6B', // Red
  '#4ECDC4', // Teal
  '#45B7D1', // Blue
  '#FFA07A', // Light Salmon
  '#98D8C8', // Mint
  '#F7DC6F', // Yellow
  '#BB8FCE', // Purple
  '#85C1E2', // Sky Blue
  '#F8B739', // Orange
  '#52B788', // Green
  '#FF85A2', // Pink
  '#A8DADC', // Powder Blue
  '#F4A261', // Sandy Brown
  '#E07A5F', // Terra Cotta
] as const

/**
 * Cities known for their cocktail bar scenes - used for random bin naming
 */
export const COCKTAIL_CITIES = [
  'Singapore', // Singapore Sling origin, Asian cocktail hub
  'New York', // Birthplace of many classics, countless speakeasies
  'London', // Dominates World's 50 Best Bars lists
  'Tokyo', // Precision bartending, perfect ice
  'New Orleans', // Sazerac, Hurricane, French 75 origins
  'Havana', // Mojito, Daiquiri, Cuba Libre birthplace
  'Paris', // Harry's Bar, classic French cocktail culture
  'Mexico City', // Mezcal renaissance, cantina culture
  'Hong Kong', // Asian cocktail scene leader
  'Barcelona', // Mediterranean cocktail culture
  'Sydney', // Australian craft cocktail scene
  'Melbourne', // Hidden laneway bars
  'Buenos Aires', // South American cocktail culture
  'Berlin', // Underground speakeasy scene
  'Shanghai', // Speak Low bar, growing Chinese cocktail scene
  'Bangkok', // Emerging scene, Thai ingredients
  'Seoul', // Korean cocktail innovation, soju-based drinks
  'Taipei', // Taiwanese craft cocktail scene
  'Florence', // Negroni birthplace
  'Milan', // Italian aperitivo culture, Campari heritage
] as const
